import React, { useState } from 'react';

import { ActionIcon, Button, Group, Space, TextInput, Title, useMantineTheme } from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import DrawerTaxRateForm from './components/DrawerTaxRateForm';
import TaxRatesTableContainer from './components/TaxRatesTableContainer';

const TaxRates = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const taxRatePerm = hasPerm('TaxRateMutate');

  const [isCreteFormOpened, { open: openCreateForm, close: closeCreateForm }] = useDisclosure(false);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 250);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearchTerm(value);
  };
  const handleClearSearchFilter = (): void => {
    setSearchTerm('');
  };

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Tax Rates
          </Title>
          <Group>
            <TextInput
              icon={<IconSearch size={theme.fontSizes.md} />}
              placeholder='Search by name'
              value={searchTerm}
              onChange={handleSearchChange}
              rightSection={
                !!searchTerm ? (
                  <ActionIcon onClick={handleClearSearchFilter} size='md'>
                    <IconX size={theme.fontSizes.md} />
                  </ActionIcon>
                ) : (
                  <Space />
                )
              }
            />
            <Button
              leftIcon={<IconPlus size={theme.fontSizes.md} />}
              onClick={openCreateForm}
              disabled={!taxRatePerm}
            >
              Tax Rate
            </Button>
          </Group>
        </Group>
      </PageHeader>
      <TaxRatesTableContainer searchTerm={debouncedSearchTerm} permission={taxRatePerm} />
      <DrawerTaxRateForm
        type='create'
        formId='create-tax-rate-form'
        opened={isCreteFormOpened}
        closeHandler={closeCreateForm}
        title={<Title order={3}>Create Tax Rate</Title>}
      />
    </>
  );
};

export default TaxRates;
